import type { Reference, RequestGroup } from '@medplum/fhirtypes'
import { ExtendedResource } from '#src/ExtendedResource.ts'
import { getReferenceString } from '#src/references.ts'

export class ExtendedRequestGroup extends ExtendedResource<RequestGroup> {
  static readonly RESOURCE_TYPE = 'RequestGroup'

  hasActionResource(reference: Reference): boolean {
    return (
      this.resource.action?.some(
        (action) =>
          action.resource &&
          getReferenceString(action.resource) === getReferenceString(reference)
      ) ?? false
    )
  }
}
